import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import api from '../api';
import MoviePosterImage from '../components/movie-poster-image/movie-poster-image.component';


class MovieHelper {

  static FormatDateValue(dateStr, formatStr = 'MM/DD/YYYY') {
    let retval = null;
    if (dateStr) {
      retval = dateStr;
      try {
        retval = moment(dateStr).format(formatStr);
      } catch (ex) {}
    }
    return retval;
  }

  static FormatLongDateValue(dateStr, formatStr = 'ddd M/D/YYYY') {
    return this.FormatDateValue(dateStr, formatStr);
  }

  formatPosterUrl(item, resolutionSize = '500x500') {
    return api.movies.getPosterUrlFromMovie(item, { res: resolutionSize });
  }

  formatPosterUrlFromMovieId(movieId, resolutionSize = '500x500') {
    return api.movies.getPosterUrlFromMovieId(movieId, null, { res: resolutionSize });
  }

  formatPosterAndTitle(item) {
    // item.posterUrl = api.movies.getPosterUrlFromMovie(item, { res: '72x72' });
    return (
      <div className="movie-title-preview">
        {/* <div className="poster-image"><img src={item.posterUrl} alt="" /></div> */}
        <MoviePosterImage movie={item} resolutionSize="72x72" />
        <div className="movie-title">{item.title}</div>
      </div>
    );
  }

  format3D(item) {
    return (item && item.is3D === '1')? '3D': '';
  }

  formatDuration(item) {
    return this.formatDurationValue(item && item.durationMinsIntValue);
  }

  formatDurationValue(durationMins) {
    let retval = null;
    if (_.isFinite(durationMins) && durationMins > 0) {
      let hrs = Math.floor(durationMins / 60);
      let mins = durationMins % 60;
      let parts = [];
      if (hrs >= 1) {
        parts.push(hrs + 'h');
      }
      if (hrs >= 1 || mins >= 1) {
        parts.push(mins + 'min');
      }
      if (!_.isEmpty(parts)) {
        retval = _.join(parts, ' ');
      }
    }
    return retval;
  }

  formatDateValue(dateStr, formatStr = 'MM/DD/YYYY') {
    return this.constructor.FormatDateValue(dateStr, formatStr);
  }

  formatLongDateValue(dateStr, formatStr = 'ddd M/D/YYYY') {
    return this.constructor.FormatLongDateValue(dateStr, formatStr);
  }

  formatReleaseDate(item) {
    return this.formatLongDateValue(item && item.releaseDateMomentValue);
  }

  formatShortDateRange(startDateStr, endDateStr) {
    return this.formatLongDateRange(startDateStr, endDateStr, 'M/D/YYYY', 'M/D/YYYY')
  }

  formatLongDateRange(startDateStr, endDateStr, formatStr1 = 'ddd MMM D', formatStr2 = 'ddd MMM D, YYYY') {
    // assumes both dates are valid dates
    let startDate = moment(startDateStr);
    let endDate = moment(endDateStr);
    let validStartDate = (startDate && startDate.isValid());
    let validEndDate = (endDate && endDate.isValid());

    let parts = [];
    if (validStartDate || validEndDate) {
      if (!validStartDate) { startDate = endDate; }
      if (!validEndDate) { endDate = startDate; }
      if (startDate.isAfter(endDate)) {
        let tmp = startDate;
        startDate = endDate;
        endDate = tmp;
      }

      if (!startDate.isSame(endDate, 'year')) {
        formatStr1 = formatStr2;
      }

      parts.push(startDate.format(formatStr1));
      parts.push(endDate.format(formatStr2));
    }

    return _.join(parts, ' - ');
  }

  calcShowtimeStats(showtimeModel) {
    // <div class="desc">7 Days, 36 Showings,</div>
    // <div class="desc">5 Movies, 3 Theaters, 4 Screens</div>

    let numMovies = 0;
    let numDays = 0;
    let numShowings = 0;
    let numTheaters = 0;
    let numScreens = 0;

    let showtimes = showtimeModel && showtimeModel.showtimes;

    numMovies = _.chain(showtimes)
      .map('movieId')
      .uniq()
      .compact()
      .size()
      .value();

    numTheaters = _.chain(showtimes)
      .map('theaterId')
      .uniq()
      .compact()
      .size()
      .value();

    numScreens = _.chain(showtimes)
      .compact()
      .map(v => v.theaterId + '|' + v.screenId)
      .uniq()
      .compact()
      .size()
      .value();

    // let minDate = moment(showtimeItem.min_date);
    // let maxDate = moment(showtimeItem.max_date);

    let tmpShowtimeDates = {};

    _.each(showtimes, showtime => {
      if (!showtime) { return; }
      let startDate = moment(showtime.startDate);
      let endDate = moment(showtime.endDate);
      let traceDate = startDate;

      while (traceDate.isSameOrBefore(endDate)) {
        let tmpTimes = _.cloneDeep(showtime.generalShowtimes || []);

        _.each(showtime.showtimeExceptions, exception => {
          if (!exception || !exception.type || !exception.date || !exception.time) { return; }
          let exceptionDate = moment(exception.date, ['YYYY-MM-DD', 'MM/DD/YYYY', 'M/DD/YYYY', 'M/D/YYYY']);
          if (traceDate.isSame(exceptionDate, 'day')) {
            if (exception.type === 'add') {
              if (!_.includes(tmpTimes, exception.time)) {
                tmpTimes.push(exception.time);
              }
            } else if (exception.type === 'remove') {
              tmpTimes = _.remove(tmpTimes, v => (v !== exception.time));
            }
          }
        });


        if (!_.isEmpty(tmpTimes)) {
          numShowings += _.size(tmpTimes);
          tmpShowtimeDates[traceDate.format('MM/DD/YYYY')] = true;
        }

        traceDate.add(1, 'day');
      }
    });

    numDays = _.size(tmpShowtimeDates);

    return {
      numMovies,
      numDays,
      numShowings,
      numTheaters,
      numScreens
    };
  }

}


const movieHelper = new MovieHelper();
export default movieHelper;
export { MovieHelper };
